import React from 'react';
import { Redirect } from 'react-router-dom';
import { Button, Container } from 'reactstrap';
import Loader from '../../components/Loader';
import Text from '../../components/Text';
import FormValidator from '../../utils/FormValidator';
import SITE_PATHS from '../../config/sitePaths';
import PrefillError from './Prefill.error';

import styles from './Prefill.styles.module.scss';

const generateValidateFormBeforeProceeding = (props) => () => {
  const {
    formData,
    onNext,
    validationConfig,
    onFormValidated,
  } = props;
  const validator = new FormValidator(validationConfig);
  const result = validator.validate(formData);
  onFormValidated(result);
  if (result.isInvalid) return;
  onNext();
};

export default function PrefillView(props) {
  const {
    config,
    children,
    error,
    loading,
  } = props;
  if (loading) return <Loader />;
  if (!config.prefill?.enabled) return <Redirect to={SITE_PATHS.ROOT} />;

  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        <h3>
          <Text value="Application Prefill" />
        </h3>
      </div>
      <div className="form-group-wrapper">
        <Container>
          { children }
          <PrefillError error={error} />
          <Button
            onClick={generateValidateFormBeforeProceeding(props)}
          >
            <Text value="Next" />
          </Button>
        </Container>
      </div>
    </div>
  );
}
